import { uuidv4 } from '@bothrs/util/random'
import { t } from '@lingui/macro'

export type SelectedFile = {
  id: string
  file: File
  previewUrl: string | null
  error: string | null
  uploading: boolean
  fileId: string | null
  uploadError: string | null
}

export function validateFile(file: File, allowedTypes: Array<{ mimeType: string; maxSizeMb: number }>): string | null {
  if (allowedTypes.length === 0) return null

  const allowedMimes = allowedTypes.map((at) => at.mimeType)
  if (!allowedMimes.includes(file.type)) {
    return t({
      id: 'file-upload.error.type',
      message: 'Bestandstype niet toegestaan',
    })
  }

  const entry = allowedTypes.find((at) => at.mimeType === file.type)
  if (entry && file.size > entry.maxSizeMb * 1024 * 1024) {
    return t({
      id: 'file-upload.error.size',
      message: 'Te groot, max. {maxMb} MB',
      values: { maxMb: entry.maxSizeMb },
    })
  }

  return null
}

export function toSelectedFile(file: File, allowedTypes: Array<{ mimeType: string; maxSizeMb: number }>): SelectedFile {
  return {
    id: uuidv4(),
    file,
    previewUrl: file.type.startsWith('image/') ? URL.createObjectURL(file) : null,
    error: validateFile(file, allowedTypes),
    uploading: false,
    fileId: null,
    uploadError: null,
  }
}

export function formatConstraintHint(allowedTypes: Array<{ mimeType: string; maxSizeMb: number }>): string {
  if (allowedTypes.length === 0) return ''
  const separator = t({
    id: 'file-upload.constraint-hint.separator',
    message: ' of ',
  })
  const labels = allowedTypes.map(({ mimeType }) => mimeType.split('/')[1].toLowerCase()).join(separator)

  const maxMb = Math.min(...allowedTypes.map((at) => at.maxSizeMb))
  return t({
    id: 'file-upload.constraint-hint',
    message: 'Enkel {labels}, max. {maxMb} MB. De bestanden komen in je patiëntendossier terecht.',
    values: { labels, maxMb },
  })
}
